<template>
  <!-- En tu index.html -->
  <link
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    rel="stylesheet"
  />

  <div class="bg-white text-gray-800 font-sans">
    <!-- HERO / HEADER -->
    <header class="relative isolate overflow-hidden min-h-[70vh] md:min-h-[85vh]">
      <img
        src="/fondologin.jpg"
        alt="Nat Spa"
        class="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div class="absolute inset-0 bg-gradient-to-br from-black/70 via-black/40 to-transparent"></div>
      <div class="relative z-10 mx-auto flex h-full max-w-6xl flex-col items-center justify-center gap-6 px-4 py-20 text-center text-white">
        <div class="flex flex-col items-center gap-2">
          <img
            :src="logo"
            alt="NatSpa Logo"
            class="w-28 rounded-full border border-white/30 shadow-lg backdrop-blur"
          />
          <p class="text-sm uppercase tracking-[0.4em] text-white/80">Wellness & Estética</p>
        </div>
        <h1 class="text-4xl font-black leading-tight sm:text-5xl md:text-6xl">
          NAT SPA & WELLNESS CENTER
        </h1>
        <p class="max-w-2xl text-lg text-white/90 md:text-xl">
          Relajación, belleza y bienestar con el lujo de los mejores spas del mundo.
        </p>
        <div class="flex flex-wrap items-center justify-center gap-4">
          <router-link to="/solicitar-paciente" class="inline-flex items-center gap-2 rounded-full bg-emerald-500 px-6 py-2.5 text-base font-semibold text-white shadow-lg shadow-emerald-500/30 transition hover:-translate-y-0.5 hover:bg-emerald-600 sm:px-8 sm:py-3 sm:text-lg">
            Solicitar cita <i class="fas fa-arrow-right"></i>
          </router-link>
          <router-link to="/login" class="inline-flex items-center gap-2 rounded-full border border-white/60 px-6 py-2.5 text-base font-semibold text-white transition hover:bg-white/10 sm:px-8 sm:py-3 sm:text-lg">
            Iniciar sesión
          </router-link>
        </div>
        <div class="mt-6 grid w-full gap-4 sm:grid-cols-3">
          <div class="rounded-2xl bg-white/10 px-6 py-4 backdrop-blur">
            <p class="text-3xl font-bold text-emerald-200">+15</p>
            <p class="text-sm uppercase tracking-wide text-white/80">tratamientos signature</p>
          </div>
          <div class="rounded-2xl bg-white/10 px-6 py-4 backdrop-blur">
            <p class="text-3xl font-bold text-emerald-200">Wellness</p>
            <p class="text-sm uppercase tracking-wide text-white/80">cuerpo, mente y espíritu</p>
          </div>
          <div class="rounded-2xl bg-white/10 px-6 py-4 backdrop-blur">
            <p class="text-3xl font-bold text-emerald-200">100%</p>
            <p class="text-sm uppercase tracking-wide text-white/80">experiencia personalizada</p>
          </div>
        </div>
      </div>
    </header>

    <!-- BANNER DINÁMICO -->
    <Banner />

    <!-- SERVICIOS DINÁMICOS -->
    <section class="py-20 bg-gray-100 text-center">
      <h2 class="text-3xl font-bold mb-10">Nuestros Servicios</h2>

      <div
        v-if="categorias.length"
        class="grid md:grid-cols-3 gap-8 px-4 max-w-6xl mx-auto"
      >
        <div
          v-for="cat in categorias"
          :key="cat.id"
          class="bg-white rounded-lg shadow-lg p-6 hover:scale-105 transition-transform cursor-pointer"
          @click="abrirModal(cat)"
        >
          <img
            :src="cat.imagenUrl || '/placeholder.jpg'"
            class="rounded-md mb-4 w-full h-48 object-cover"
            :alt="cat.nombre"
          />
          <h3 class="text-xl font-semibold mb-2">{{ cat.nombre }}</h3>
          <p>{{ cat.descripcion }}</p>
        </div>
      </div>

      <p v-else class="text-gray-400 text-sm italic">
        No hay servicios disponibles aún.
      </p>
    </section>

    <!-- TIENDA ONLINE DESTACADA -->
    <section class="py-20 bg-white border-y border-gray-100">
      <div class="max-w-6xl mx-auto px-4 space-y-10">
        <div class="text-center">
          <p class="text-sm uppercase tracking-[0.4em] text-emerald-500">
            Tienda Online
          </p>
          <h2 class="text-4xl md:text-5xl font-extrabold font-serif tracking-wide text-gray-800">
            Rituals <span class="text-emerald-600">para continuar en casa</span>
          </h2>
          <p class="mt-4 text-lg text-gray-500 max-w-3xl mx-auto">
            Encuentra productos profesionales, kits de regalo y accesorios diseñados para
            prolongar tus tratamientos. Compra desde cualquier lugar y recibe con empaque premium.
          </p>
        </div>

        <div v-if="productosDestacados.length" class="grid gap-8 md:grid-cols-3">
          <article
            v-for="producto in productosDestacados"
            :key="producto.id"
            class="rounded-3xl border border-gray-100 shadow-lg bg-white overflow-hidden flex flex-col"
          >
            <img
              :src="producto.imagenUrl || '/placeholder.jpg'"
              :alt="producto.nombre"
              class="h-52 w-full object-cover"
            />
            <div class="flex flex-1 flex-col gap-4 p-6 text-left">
              <p class="text-xs uppercase tracking-[0.3em] text-emerald-500">Nat Spa Store</p>
              <h3 class="text-2xl font-semibold text-gray-900">{{ producto.nombre }}</h3>
              <p class="text-sm text-gray-500 line-clamp-3">
                {{ producto.descripcion || "Fórmula curada por nuestro equipo clínico para cuidar tu piel." }}
              </p>
              <span class="text-2xl font-bold text-emerald-600">
                {{ producto.precio ? `$${Number(producto.precio).toFixed(2)}` : "Consultar" }}
              </span>
              <router-link
                to="/tienda"
                class="inline-flex items-center gap-2 text-emerald-600 font-semibold hover:text-emerald-700 transition"
              >
                Ver más <i class="fas fa-arrow-right text-sm"></i>
              </router-link>
            </div>
          </article>
        </div>
        <div v-else class="text-center text-gray-400 italic">
          Estamos preparando nuevas colecciones exclusivas para la tienda.
        </div>

        <div class="grid gap-6 md:grid-cols-3">
          <div
            v-for="beneficio in tiendaHighlights"
            :key="beneficio.titulo"
            class="rounded-3xl bg-gray-50 p-6 text-left border border-gray-100"
          >
            <div class="mb-3 inline-flex h-12 w-12 items-center justify-center rounded-full bg-white text-emerald-600 shadow">
              <i :class="beneficio.icono"></i>
            </div>
            <h3 class="text-xl font-semibold text-gray-800">{{ beneficio.titulo }}</h3>
            <p class="mt-2 text-sm text-gray-500">{{ beneficio.descripcion }}</p>
          </div>
        </div>

        <div class="text-center">
          <router-link
            to="/tienda"
            class="inline-flex items-center gap-2 rounded-full px-8 py-3 bg-emerald-500 text-white text-lg font-semibold shadow-lg hover:bg-emerald-600 transition"
          >
            Visitar tienda online <i class="fas fa-store"></i>
          </router-link>
        </div>
      </div>
    </section>

    <!-- SOBRE NOSOTROS EXPANDIBLE -->
    <section class="py-20 px-4 text-center bg-gray-50 max-w-3xl mx-auto">
      <h2
        class="text-4xl font-extrabold font-serif tracking-wide text-gray-800 mb-8"
      >
        Sobre Nosotros
      </h2>

<!-- Imagen de perfil -->
<div class="flex justify-center mb-6">
  <img 
    src="/foto_nat.jpeg" 
    alt="Vanessa San Miguel" 
    class="w-32 h-32 rounded-full object-cover shadow-lg border-4 border-white" 
  />
</div>

      <!-- Párrafos iniciales -->
      <p class="text-lg leading-relaxed font-light text-gray-700">
        En Nat Spa & Wellness Center, ofrecemos un santuario de relajación y
        rejuvenecimiento, en medio del bullicio de la vida cotidiana.
      </p>

      <transition name="fade">
        <div v-if="verMas" class="mt-6 space-y-4">
          <p class="text-lg leading-relaxed font-light text-gray-700">
            Nuestra esteticista y terapista holística, Vanessa San Miguel, se
            encargará de proveer una experiencia de paz, nutriendo su mente,
            cuerpo y espíritu. Acompáñenos y descubra el poder transformativo
            del autocuidado.
          </p>
          <p class="text-lg leading-relaxed font-light text-gray-700">
            En mi trayectoria por el mundo de la estética ha estado presente el
            deseo de transformar vidas. Todo comenzó con una clase de Reiki en
            el 2018. Con ella, nació el sueño y la visión de compartir con el
            mundo mi aprecio por el bienestar y la belleza.
          </p>
          <p class="text-lg leading-relaxed font-light text-gray-700">
            La estética se ha convertido en más que una profesión: es una pasión
            que impulsa mis días. Cada tratamiento representa una oportunidad
            para no solo realzar la belleza exterior, sino también promover el
            equilibrio y la armonía interna en cada uno de mis clientes.
          </p>
        </div>
      </transition>

      <!-- Botón toggle -->
      <button
        @click="verMas = !verMas"
        class="inline-flex items-center justify-center gap-2 px-4 py-2 sm:px-6 sm:py-3 rounded-lg sm:rounded-full font-semibold text-sm sm:text-base transition duration-300 border border-green-600 text-green-600 bg-white hover:bg-green-700 hover:text-white"
      >
        <i class="fas fa-plus-circle"></i>
        {{ verMas ? "Ver menos" : "Ver más" }}
      </button>
    </section>

    <footer class="bg-gray-900 text-white py-10 px-6">
      <div
        class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 items-center"
      >
        <!-- Información Legal -->
        <div class="text-center md:text-left">
          <p class="text-sm text-gray-400">
            &copy; {{ new Date().getFullYear() }}
            <strong>NAT SPA & WELLNESS CENTER</strong>. Todos los derechos
            reservados.
          </p>
          <p class="text-sm text-gray-500 mt-1">
            Desarrollado con ❤️ para tu bienestar.
          </p>
        </div>

        <!-- Redes Sociales -->
        <div class="flex justify-center md:justify-end items-center space-x-6">
          <a
            href="https://wa.me/1234567890"
            target="_blank"
            aria-label="WhatsApp"
            class="hover:text-green-400 transition"
          >
            <i class="fab fa-whatsapp text-2xl"></i>
          </a>
        </div>
      </div>
    </footer>

    <!-- 🟢 Floating Action Button: WhatsApp -->
    <div
      class="fixed right-2 top-1/2 -translate-y-1/2 z-50 flex flex-col gap-2"
    >
      <!-- WhatsApp Button -->
      <div class="relative whatsapp-container" @click="toggleBtn('wa')">
        <button
          class="whatsapp-btn flex items-center justify-center bg-green-500 hover:bg-green-600 text-white rounded-full shadow-none transition-all focus:outline-none focus:ring-0 p-0"
          style="
            width: 48px !important;
            height: 48px !important;
            min-width: 48px !important;
            min-height: 48px !important;
          "
          aria-label="WhatsApp"
        >
          <svg
            class="whatsapp-icon"
            fill="currentColor"
            viewBox="0 0 24 24"
            style="
              width: 36px !important;
              height: 36px !important;
              min-width: 36px !important;
              min-height: 36px !important;
            "
          >
            <path
              d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488"
            />
          </svg>
        </button>
        <div
          v-if="openBtn === 'wa'"
          class="absolute right-6 sm:right-14 top-1/2 -translate-y-1/2 bg-white text-gray-800 px-1 py-0.5 sm:px-3 sm:py-2 rounded shadow border text-xs sm:text-sm"
        >
          <a
            href="https://wa.me/17874159799"
            target="_blank"
            class="hover:underline"
          >
            Enviar mensaje
          </a>
        </div>
      </div>
    </div>

    <!-- Modal Productos de Categoría -->
    <div
      v-if="modalAbierto"
      class="fixed inset-0 z-50 bg-black/60 flex items-center justify-center px-4"
    >
      <div
        class="bg-white w-full max-w-4xl max-h-[90vh] overflow-y-auto p-6 rounded-lg shadow-xl relative"
      >
        <button
          class="absolute top-2 right-4 text-gray-500 hover:text-black text-3xl"
          @click="cerrarModal"
        >
          &times;
        </button>

        <h3 class="text-2xl font-bold mb-4 text-center">
          {{ categoriaActiva?.nombre }}
        </h3>
        <p class="text-gray-600 mb-6 text-center">
          {{ categoriaActiva?.descripcion }}
        </p>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div
            v-for="prod in productosFiltrados"
            :key="prod.id"
            class="bg-white rounded-lg shadow hover:shadow-lg transition transform hover:-translate-y-1"
          >
            <img
              :src="prod.imagenUrl || 'https://via.placeholder.com/300x200'"
              class="w-full h-48 object-cover rounded-t"
              :alt="prod.nombre"
            />
            <div class="p-4">
              <h4 class="font-semibold text-lg mb-1">{{ prod.nombre }}</h4>
              <div class="text-xl mb-2">
                <span class="text-green-700 font-bold"
                  >${{ prod.precio?.toFixed(2) || "0.00" }}</span
                >
                <span
                  v-if="prod.tipo !== 'servicio'"
                  class="text-blue-600 text-sm ml-1"
                >
                  (+imp.)
                </span>
              </div>
              <p v-if="prod.descripcion" class="text-gray-600 text-sm">
                {{ prod.descripcion }}
              </p>
            </div>
          </div>
        </div>

        <p
          v-if="!productosFiltrados.length"
          class="text-gray-500 italic mt-4 text-center"
        >
          No hay productos disponibles aún.
        </p>

        <!-- BOTÓN UNIVERSAL FUERA DEL LOOP -->
        <div class="mt-6 text-center">
          <button
            class="bg-green-600 text-white px-5 py-2.5 text-base sm:text-lg rounded hover:bg-green-700 transition"
            @click="requerirCuenta"
          >
            Solicitar servicio
          </button>
        </div>
      </div>
    </div>

    <!-- Alerta de cuenta requerida -->
    <div
      v-if="mostrarAlerta"
      class="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-4"
    >
      <div class="bg-white p-6 rounded shadow-xl w-full max-w-md text-center">
        <h3 class="text-xl font-bold mb-2">Necesitas una cuenta</h3>
        <p class="text-gray-600 mb-4">
          Para solicitar un servicio, debes iniciar sesión o registrarte como
          nuevo cliente.
        </p>
        <div class="flex flex-col sm:flex-row gap-3 justify-center">
          <router-link to="/solicitar-paciente" class="w-full sm:w-auto">
            <button
              class="w-full bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700 transition"
            >
              Crear cuenta
            </button>
          </router-link>
          <router-link to="/login" class="w-full sm:w-auto">
            <button
              class="w-full bg-white border border-green-600 text-green-700 py-2 px-4 rounded hover:text-green-900 transition"
            >
              Iniciar sesión
            </button>
          </router-link>
        </div>
        <button
          class="mt-4 text-sm text-gray-500 hover:text-gray-800"
          @click="mostrarAlerta = false"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "@/firebase";
import Banner from "@/components/Banner.vue";
import logo from "@/assets/logo.png";
export default {
  name: "LandingPage",
  components: { Banner },
  data() {
    return {
      logo,
      categorias: [],
      productos: [],
      openBtn: null,
      verMas: false,
      productosPorCategoria: {},
      modalAbierto: false,
      categoriaActiva: null,
      mostrarAlerta: false,
      q: "",
      tiendaHighlights: [
        {
          titulo: "Rutinas clínicas",
          descripcion: "Colecciones curadas por Vanessa con respaldo profesional para cuidar tu piel.",
          icono: "fas fa-spa",
        },
        {
          titulo: "Regalos conscientes",
          descripcion: "Sets exclusivos con empaque premium para sorprender en cualquier ocasión.",
          icono: "fas fa-gift",
        },
        {
          titulo: "Entrega flexible",
          descripcion: "Recoge en Nat Spa o recibe en casa con seguimiento personalizado.",
          icono: "fas fa-truck",
        },
      ],
    };
  },

  computed: {
    productosFiltrados() {
      if (!this.categoriaActiva) return [];
      return this.productosPorCategoria[this.categoriaActiva.id] || [];
    },
    filteredProductos() {
      return this.productos.filter((p) =>
        (p.nombre || "").toLowerCase().includes(this.q.toLowerCase())
      );
    },
    productosDestacados() {
      return this.productos.slice(0, 3);
    },
  },
  methods: {
    toggleBtn(key) {
      this.openBtn = this.openBtn === key ? null : key;
    },
    abrirModal(cat) {
      this.categoriaActiva = cat;
      this.modalAbierto = true;
      this.mostrarAlerta = false;
    },
    cerrarModal() {
      this.modalAbierto = false;
      this.categoriaActiva = null;
      this.mostrarAlerta = false;
    },
    requerirCuenta() {
      console.log(" Click detectado");
      this.mostrarAlerta = true;
    },
    openWhatsApp() {
      window.open("https://wa.me/1234567890", "_blank");
    },
  },
  async mounted() {
    // 1. Productos visibles
    const prodSnap = await getDocs(
      query(collection(db, "productos"), where("visible", "==", true))
    );
    const allProductos = prodSnap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    
    this.productos = allProductos.filter(
      (p) =>
        p.visible &&
        (p.mostrarEn !== "pos" ||
          String(p.tipo || "").toLowerCase() === "servicio")
    );

    
    const catSnap = await getDocs(
      query(collection(db, "categorias"), where("visibleEnLanding", "==", true))
    );
    this.categorias = catSnap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    
    this.productosPorCategoria = {};
    this.categorias.forEach((cat) => {
      this.productosPorCategoria[cat.id] = this.productos.filter(
        (p) =>
          p.categoria === cat.id &&
          String(p.tipo || "").toLowerCase() === "servicio"
      );
    });

  },
};
</script>

<style scoped>
/* Tipografía base */
body {
  font-family: "Poppins", sans-serif;
}

/* Transición para imágenes */
img {
  transition: transform 0.3s ease;
}

/* Transición de fade Vue */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* RESPONSIVE PERSONALIZADO */
@media (max-width: 640px) {
  section {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .text-lg {
    font-size: 1rem;
    line-height: 1.6;
  }

  h2 {
    font-size: 1.75rem;
  }

  .rounded-full {
    width: 6rem;
    height: 6rem;
  }

  .space-y-4 > * + * {
    margin-top: 1rem;
  }

  /* WhatsApp button responsive sizes */
  .whatsapp-btn,
  button[aria-label="WhatsApp"],
  .whatsapp-container button {
    width: 48px !important;
    height: 48px !important;
    min-width: 48px !important;
    min-height: 48px !important;
    display: flex !important;
    visibility: visible !important;
    opacity: 1 !important;
  }

  .whatsapp-icon,
  .whatsapp-container svg {
    width: 36px !important;
    height: 36px !important;
    min-width: 36px !important;
    min-height: 36px !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }

  @media (min-width: 640px) {
    .whatsapp-btn,
    button[aria-label="WhatsApp"],
    .whatsapp-container button {
      width: 72px !important;
      height: 72px !important;
      min-width: 72px !important;
      min-height: 72px !important;
      display: flex !important;
      visibility: visible !important;
      opacity: 1 !important;
    }

    .whatsapp-icon,
    .whatsapp-container svg {
      width: 44px !important;
      height: 44px !important;
      min-width: 44px !important;
      min-height: 44px !important;
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
    }
  }
}

</style>
